<template>
  <div class="row">
    <div
      :class="{'form-sections col-md-6': !isBundleFlow, 'form-sections col-md-12': isBundleFlow}" v-for="(section, j) in sections" :key="j">
      <div class="row" :class="{'no-gutters': isBundleFlow}">
        <div v-if="(section === 'untitled')" class="col-12 col-lg-6 text-center" :class="{'carrier-logo-property': isBundleFlow}">
          <img class="carrier-logo" height="auto" width="auto" :src="pageData.carrier_final_rate_section.logo_path" alt="Progressive"/>
          <div class="smaller-font-content font-weight-bold text-primary" v-html="pageData.carrier_final_rate_section.blurb"></div>
        </div>

        <div :class="(section === 'untitled' ? 'col-12 col-lg-6' : 'col-md-12')">
        <div :class="(section === 'untitled' ? 'shadow-none' : 'shadow-sm rounded')">
          <div v-if="section !== 'untitled'" class="py-2 pl-3 mb-2 text-white bg-primary rounded-top" role="heading" aria-level="3">
            {{ section }}
          </div>

          <div class="mb-3" v-for="(subSection, k) in subSections" :key="k" v-if="group[section][subSection]">
            <div v-if="subSection !== 'untitled'" class="py-1 pl-3 mb-2 text-grey-dark bg-faint-gray" role="heading" aria-level="4">
              {{ subSection }}
            </div>

            <div class="row mx-0">
              <div v-for="(subSubSection, l) in subSubSections" :key="l" v-if="group[section][subSection][subSubSection]" :class="(subSubSection === 'untitled' ? 'col-md-12 px-0' : 'col-12 col-lg-6 px-0 mb-3')">
                <div :class="(subSubSection === 'untitled' ? 'shadow-none' : 'mx-3 shadow-sm rounded')">
                  <div v-if="subSubSection !== 'untitled'" class="py-1 pl-3 mb-2 text-white bg-primary rounded-top"  role="heading" aria-level="5">
                    {{ subSubSection }}
                  </div>

                  <field-display v-for="(fieldData, m) in group[section][subSection][subSubSection]" :key="m" :fieldData="fieldData"></field-display>
                </div>
              </div>
            </div>

          </div>
        </div>
        </div>
      </div>
    </div>
    <div v-if="pageData.bill_plan" :class="{'form-sections col-md-6': !isBundleFlow, 'form-sections col-md-12': isBundleFlow}">
    <div class="shadow-sm">
      <div class="py-2 pl-3 text-white bg-primary rounded-top" role="heading" aria-level="3">
        {{ pageData.bill_plan.bill_plan_name }}
      </div>
      <!--TABLE HEADER-->
      <div class="row mx-0 py-2 font-weight-bold bg-faint-gray text-grey-dark">
        <div class="col-6">Installments</div>
        <div class="col-3">Due Date</div>
        <div class="col-3">Amount Due</div>
      </div>
      <div v-for="(row, key) in pageData.bill_plan.bill_plan_installments" :key="key" id="month-1" class="row mx-0 py-2 breakdown-item border-bottom">
        <div class="col-6">{{ row.installment_name }}</div>
        <div class="col-3">{{ row.installment_date}}</div>
        <div class="col-3">{{ row.amount }}</div>
      </div>
      <div class="row mx-0 py-2 justify-content-end text-white bg-primary font-weight-bold rounded-bottom">
        <div class="col-3">Total: {{ pageData.bill_plan.bill_plan_total }}</div>
      </div>
    </div>
    </div>
    <!--TOTAL-->
  </div>
</template>

<script>
import FieldDisplay from './FieldDisplay';

export default {
  props: ['group', 'pageData'],
  data() {
    return {
      sections: [],
      subSections: [],
      subSubSections: [],
    };
  },
  components: {
    FieldDisplay,
  },
  computed: {
    isBundleFlow() {
      return sessionStorage.getItem('flowType') === 'bundle' || sessionStorage.getItem('flowType') === 'cabundle' || sessionStorage.getItem('flowType') === 'rabundle';
    },
  },
  methods: {
    /**
     * Remove duplicate values from an array.
     *
     * This is necessary to avoid repeating the 'untitled' value that represents
     * sections that do not have a name. Since all of the data is nested within
     * a section, a subsection, and a subsubsection, each needs a name to group
     * the fields together under their respective hierarchy. If, in the future,
     * the data is received in the tree structure it is supposed to be represented
     * as, then this and other steps are not necessary.
     */
    removeDuplicateValues(section) {
      return section.filter((item, pos, self) => self.indexOf(item) === pos);
    },
  },
  mounted() {
    /* eslint-disable no-restricted-syntax, no-prototype-builtins */

    for (const section in this.group) {
      if (this.group.hasOwnProperty(section)) {
        if (!this.sections[section]) {
          this.sections.push(section);
        }

        for (const subSection in this.group[section]) {
          if (this.group[section].hasOwnProperty(subSection)) {
            if (!this.subSections[subSection]) {
              this.subSections.push(subSection);
            }

            for (const subSubSection in this.group[section][subSection]) {
              if (this.group[section][subSection].hasOwnProperty(subSubSection)) {
                if (!this.subSubSections[subSubSection]) {
                  this.subSubSections.push(subSubSection);
                }
              }
            }
          }
        }
      }
    }

    this.sections = this.removeDuplicateValues(this.sections);
    this.subSections = this.removeDuplicateValues(this.subSections);
    this.subSubSections = this.removeDuplicateValues(this.subSubSections);
  },
};
</script>

<style scoped lang="scss">

label {
  display: inline-block;
  margin-bottom: 0.25rem;
  font-weight: 600;
  max-width: 90%;
}

img.carrier-logo{
  width: 100% !important;
  max-width: 200px !important;
  height: inherit !important;
}

.breakdown-item.border-bottom{
  border-bottom: 1px solid #CCC !important;
}
.bg-faint-gray {
  background-color: $var-alert-primary;
}
.text-grey-dark {
  color: $var-color-graydark;
}
.carrier-logo-property {
  min-height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/FormSections.vue?45160991